import React from 'react';

import { Document as StyledDocument } from './Document.styles.js';

import Loading from '../../components/Loading';
import Header from '../../components/Header';

import { formatCpf } from '../../utils/formatter.js';

function Document({
	loading,
	document,
	submit,
	documentTextMarkup,
	onClickSignatureBox
}) {
	if (loading || !document) {
		return <Loading />
	}

	return (
		<>
			<Header />

			<StyledDocument style={{ maxHeight: '57%', overflowY: 'scroll' }}>
				<StyledDocument.Title>
					{document?.title}
				</StyledDocument.Title>

				<StyledDocument.Paragraph style={{ marginTop: '16px', paddingBottom: '100px' }}>
					<span dangerouslySetInnerHTML={documentTextMarkup()}></span>
				</StyledDocument.Paragraph>
			</StyledDocument>

			<StyledDocument.FooterContainer>
				<StyledDocument.Footer>
					<StyledDocument.Footer.SignatureBox hasSignature={!!document?.signature_url} onClick={onClickSignatureBox}>
						{document?.signature_url ? (
							<StyledDocument.Footer.SignatureBox.Image src={document.signature_url} />
						) : (
							<StyledDocument.Footer.SignatureBox.Placeholder>Clique aqui para assinar o documento</StyledDocument.Footer.SignatureBox.Placeholder>
						)}
					</StyledDocument.Footer.SignatureBox>

					<StyledDocument.Footer.PatientInfo>
						<StyledDocument.Footer.PatientInfo.Name>{document?.destinatary?.name}</StyledDocument.Footer.PatientInfo.Name>
						<StyledDocument.Footer.PatientInfo.Cpf>{formatCpf(document?.destinatary?.cpf) || '-'}</StyledDocument.Footer.PatientInfo.Cpf>
					</StyledDocument.Footer.PatientInfo>

					<StyledDocument.Footer.Button className="af-button af-button--primary" disabled={!document?.signature_url} marginTop={16} type="primary" onClick={submit}>
						Assinar
					</StyledDocument.Footer.Button>
				</StyledDocument.Footer>
			</StyledDocument.FooterContainer>
		</>
	);
}

export default Document;
